import { KeyboardEvent } from 'react';

const onKeyPressNumbersOnly = (event: KeyboardEvent<HTMLInputElement>) => {
  const regex = /^[\d]$/;
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);
  if (!regex.test(keyValue)) {
    event.preventDefault();
  }
};

export default onKeyPressNumbersOnly;
